import styled from 'styled-components'

export const Card = styled.div`
	background: #FFFFFF;
	border: 1px solid #E5E5E5;
	border-radius: 4px;
`